module.exports = __webpack_public_path__ + "img/arrow-select.dcf4ec80.svg";